module.exports = __webpack_public_path__ + "img/qinghua.c2d465fc.png";